export class BaseApi {
  protected baseUrl = '/api'
}
